import React, { useEffect, useState } from "react";
import CounsellorNavbar from "../CounsellorLayout/CounsellorNavbar";
import CounsellorSidebar from "../CounsellorLayout/CounsellorSidebar";
import CounsellorFooter from "../CounsellorLayout/CounsellorFooter";
import { Container, Card, Table } from "react-bootstrap";
import { API_URL } from "../../../Constant";
import zoomicon from "../../../assets/img/zoomicon.png";
import "../../Counsellor/Counsellor.css";
import { FaCalendarAlt, FaCalendarCheck, FaCalendarPlus } from "react-icons/fa";
const CounsellorDashboard = () => {
  const [appointments, setAppointments] = useState([]);
  const [pastAppointments, setPastAppointments] = useState([]);

  const [currentTime, setCurrentTime] = useState("");
  const loginid = localStorage.getItem("loginId");

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const response = await fetch(
          `${API_URL}api/Counsellor/GetAptDetailsForCounsellor/${loginid}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch appointments");
        }

        const data = await response.json();
        console.log("Appointments:", data);
        ;

        const today = new Date().toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }).split("/").join("-");

        const filteredUpcomingAppointments = data.filter((appointment) => {
          const appointmentDate = new Date(appointment.appointmentDate).toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }).split("/").join("-");
          return appointmentDate >= today;
        });
        setAppointments(filteredUpcomingAppointments);
      
        const filteredPastAppointments = data.filter((appointment) => {
          const appointmentDate = new Date(appointment.appointmentDate).toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }).split("/").join("-");
          return appointmentDate < today;
        });
        setPastAppointments(filteredPastAppointments);


      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };

    fetchAppointments();
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const formattedTime = now.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata", // IST timezone
        weekday: "short", // e.g., Tue
        year: "numeric",
        month: "short", // e.g., Mar
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true, // 12-hour format
      });

      setCurrentTime(formattedTime);
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <CounsellorNavbar />
      <div className="d-flex">
        <CounsellorSidebar />
        <Container fluid className="p-4">
          {/* ✅ Display Current Date and Time */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <h2 className="cheading">Dashboard</h2>

            <span
              style={{
                fontSize: "1rem",
                fontWeight: "500",
                color: "#333",
              }}
            >
              📅 {currentTime}
            </span>
          </div>

          <div className="row">
            <div className="col-md-3">
              <Card className="shadow-sm" style={{ padding: "0px" }}>
                <Card.Body
                  className="alert alert-primary alert-dismissible fade show"
                  style={{
                    marginBottom: "0px",
                    borderBottom: "3px solid darkblue",
                  }}
                >
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left", paddingBottom: "7px" }}
                    >
                      Appointments
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }} className="row p-0 m-0">
                    <div className="col-md-8 p-0 m-0"></div>
                    <div
                      className="col-md-4 p-0 m-0"
                      style={{ textAlign: "right" }}
                    >
                      <p
                        className="mb-0"
                        style={{ fontSize: "1.5rem", fontWeight: "600" }}
                      >
                        46
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="col-md-3">
              <Card className="shadow-sm" style={{ padding: "0px" }}>
                <Card.Body
                  className="alert alert-secondary alert-dismissible fade show"
                  style={{
                    marginBottom: "0px",
                    borderBottom: "3px solid grey",
                  }}
                >
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left", paddingBottom: "7px" }}
                    >
                      Patients
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }} className="row p-0 m-0">
                    <div className="col-md-8 p-0 m-0"></div>
                    <div
                      className="col-md-4 p-0 m-0"
                      style={{ textAlign: "right" }}
                    >
                      <p
                        className="mb-0"
                        style={{ fontSize: "1.5rem", fontWeight: "600" }}
                      >
                        200
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="col-md-3">
              <Card className="shadow-sm" style={{ padding: "0px" }}>
                <Card.Body
                  className="alert alert-danger alert-dismissible fade show"
                  style={{
                    marginBottom: "0px",
                    borderBottom: "3px solid red",
                  }}
                >
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left", paddingBottom: "7px" }}
                    >
                      Earning
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }} className="row p-0 m-0">
                    <div className="col-md-8 p-0 m-0"></div>
                    <div
                      className="col-md-4 p-0 m-0"
                      style={{ textAlign: "right" }}
                    >
                      <p
                        className="mb-0"
                        style={{ fontSize: "1.5rem", fontWeight: "600" }}
                      >
                        500 $
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="col-md-3">
              <Card className="shadow-sm" style={{ padding: "0px" }}>
                <Card.Body
                  className="alert alert-warning alert-dismissible fade show"
                  style={{
                    marginBottom: "0px",
                    borderBottom: "3px solid orange",
                  }}
                >
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left", paddingBottom: "7px" }}
                    >
                      Cancelled Appointments
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }} className="row p-0 m-0">
                    <div className="col-md-8 p-0 m-0"></div>
                    <div
                      className="col-md-4 p-0 m-0"
                      style={{ textAlign: "right" }}
                    >
                      <p
                        className="mb-0"
                        style={{ fontSize: "1.5rem", fontWeight: "600" }}
                      >
                        12
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <div
                className="alert alert-success alert-dismissible fade show"
                role="alert"
                style={{ marginBottom: "0px", borderLeft: "5px solid green" }}
              >
                Invoice No. #354 is under review
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Card className=" shadow-sm" style={{ padding: "0px" }}>
                <Card.Body>
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left" }}
                    >
                      📅 &nbsp;Upcomming Appointments
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }}>
                    <Table bordered hover className="responsive">
                      <thead className="ctableheading">
                        <tr>
                          <th>Sr. No.</th>
                          <th>Name</th>
                          <th>Date</th>
                          <th>Time</th>
                          {/* <th>Duration (mins)</th> */}
                          <th>Meeting Link</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "#4a4a4a" }}>
                        {appointments.length > 0 ? (
                          appointments.map((appointment, index) => (
                            <tr key={appointment.appointmentId}>
                              <td>{index + 1}</td>
                              <td>
                                {appointment.clientFirstName}{" "}
                                {appointment.clientLastName}
                              </td>
                              <td>
                                {appointment.appointmentDate}
                              </td>
                              <td>

                                {appointment.appointmentTime}

                              </td>
                              {/* <td>{appointment.duration}</td> */}
                              <td>
                                <img
                                  src={zoomicon}
                                  alt="Zoom"
                                  style={{ width: "22px", marginRight: "5px" }}
                                />
                                &nbsp;
                                <a
                                  href={appointment.zoomMeetingLink}
                                  target="_blank"
                                  className="btn btn-primary"
                                  rel="noopener noreferrer"
                                  style={{ padding: "1px 6px" }}
                                >
                                  Join
                                </a>
                                <button
                                  type="button"
                                  className="btn"
                                  style={{
                                    padding: "1px 5px",
                                    marginLeft: "10px",
                                    backgroundColor: "#5CB85C",
                                    color: "white",
                                  }}
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      appointment.zoomMeetingLink
                                    );
                                  }}
                                >
                                  Copy
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No Appointments Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </div>

            <div className="col-md-6">
              <Card className=" shadow-sm" style={{ padding: "0px" }}>
                <Card.Body>
                  <center>
                    <Card.Title
                      className="csectionheading"
                      style={{ textAlign: "left" }}
                    >
                      <i
                        className="fas fa-calendar-alt"
                        style={{ marginRight: "5px", color: "#007bff" }}
                      ></i>
                      📅 &nbsp;Past Appointments
                    </Card.Title>
                  </center>
                  <div style={{ overflowX: "auto" }}>
                    <Table bordered hover className="responsive">
                      <thead className="ctableheading">
                        <tr>
                          <th>Sr. No.</th>
                          <th>Name</th>
                          <th>Date</th>
                          <th>Time</th>
                          {/* <th>Duration (mins)</th> */}
                          <th>Meeting Link</th>
                        </tr>
                      </thead>
                      <tbody style={{ color: "#4a4a4a" }}>
                        {pastAppointments.length > 0 ? (
                          pastAppointments.map((appointment, index) => (
                            <tr key={appointment.appointmentId}>
                              <td>{index + 1}</td>
                              <td>
                                {appointment.clientFirstName}{" "}
                                {appointment.clientLastName}
                              </td>
                              <td>
                                {appointment.appointmentDate}
                              </td>
                              <td>

                                {appointment.appointmentTime}

                              </td>
                              {/* <td>{appointment.duration}</td> */}
                              <td>
                                <img
                                  src={zoomicon}
                                  alt="Zoom"
                                  style={{ width: "22px", marginRight: "5px" }}
                                />
                                &nbsp;
                                <a
                                  href={appointment.zoomMeetingLink}
                                  target="_blank"
                                  className="btn btn-primary"
                                  rel="noopener noreferrer"
                                  style={{ padding: "1px 6px" }}
                                >
                                  Join
                                </a>
                                <button
                                  type="button"
                                  className="btn"
                                  style={{
                                    padding: "1px 5px",
                                    marginLeft: "10px",
                                    backgroundColor: "#5CB85C",
                                    color: "white",
                                  }}
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      appointment.zoomMeetingLink
                                    );
                                  }}
                                >
                                  Copy
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No Appointments Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Container>
      </div>
      <CounsellorFooter />
    </>
  );
};

export default CounsellorDashboard;
